export const categories = [
  { id: 1, name: "Python", categoryId: "python_programming" },
  { id: 2, name: "Web Designing", categoryId: "web_designing" },
  { id: 3, name: "Full Stact", categoryId: "full_stact" },
  { id: 4, name: "Backend", categoryId: "backend" },
  { id: 5, name: "Mobile Apps", categoryId: "react_native" },
  { id: 6, name: "MS Office", categoryId: "ms_office" },
];

export const languages = [
  { id: 1, name: "Tamil" },
  { id: 2, name: "English" },
];
